import { Injectable } from '@angular/core';
import {HttpParams} from "@angular/common/http";
import { contacto } from '../models/contacto';
import {HttpClientService} from "./http-client.service";

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  private situationUser: string;

  constructor(private http: HttpClientService) { }

  setSituationUser(situation: string) {
    this.situationUser = situation;
  }

  getSituationUser() {
    return this.situationUser;
  }

  public getByIdUsuario(idUsuario) {
    let params = new HttpParams().set("idUsuario", idUsuario);
    return this.http.getWithParams('/contacto/getbyusuario', params);
  }

  public getAll() {
    return this.http.get('/contacto/getall');
  }

  public new(contacto: contacto) {
    return this.http.post('/contacto/new', contacto);
  }

  public closeContacto(idContacto: string) {

    let json =
      {
        "idContacto": idContacto
      };

    return this.http.patch('/contacto/close', JSON.stringify(json));

  }

}
